export const paletteGray = {
  // --------- basic colors -----------
  basicColors: [
    '#000000',
    '#FcFcFd',
    '#F4F5F7',
    '#F3F4F6',
    '#E7E8EA',
    '#CECFD1',
    '#A9AAAB',
    '#616162',
    '#FFFFFF',
    '#F2F2F2',
    '#E8E6E6',
    '#D1D4DC',
    '#BEC2CB',
    '#282B33',
    '#121826',
  ],
  // ---------- semantic colors ----------
  semanticColors: {
    red: '#FF4D4F',
    green: '#29A294',
  },
};
